export function initListGroupDrawers(root = document) {
  root.querySelectorAll('[data-listgroup-drawer]').forEach((drawer) => {
    if (!(drawer instanceof HTMLElement) || drawer.dataset.listgroupDrawerBound === 'true') {
      return;
    }

    const toggle = drawer.querySelector('[data-listgroup-drawer-toggle]');
    const panel = drawer.querySelector('[data-listgroup-drawer-panel]');

    if (!(toggle instanceof HTMLButtonElement) || !(panel instanceof HTMLElement)) {
      return;
    }

    drawer.dataset.listgroupDrawerBound = 'true';

    const setPanelHeight = (height) => {
      panel.style.height = `${Math.max(0, height)}px`;
    };

    const setPanelHeightImmediate = (height) => {
      setPanelHeight(height);
      panel.getBoundingClientRect();
    };

    let animation = null;

    const animatePanel = (open) => {
      animation?.cancel();

      const startHeight = panel.getBoundingClientRect().height;

      if (open) {
        drawer.classList.add('list-group__item-stack--open');
        toggle.setAttribute('aria-expanded', 'true');
      }

      const endHeight = open ? panel.scrollHeight : 0;

      panel.style.height = `${startHeight}px`;
      panel.getBoundingClientRect();

      animation = panel.animate([{ height: `${startHeight}px` }, { height: `${endHeight}px` }], {
        duration: 400,
        easing: 'ease',
        fill: 'forwards',
      });

      animation.onfinish = () => {
        animation = null;

        if (open) {
          panel.style.height = 'auto';
          return;
        }

        drawer.classList.remove('list-group__item-stack--open');
        toggle.setAttribute('aria-expanded', 'false');
        panel.style.height = '0px';
      };

      animation.oncancel = () => {
        animation = null;
      };
    };

    setPanelHeightImmediate(drawer.classList.contains('list-group__item-stack--open') ? panel.scrollHeight : 0);

    toggle.addEventListener('click', () => {
      const isOpen = drawer.classList.contains('list-group__item-stack--open');
      animatePanel(!isOpen);
    });
  });
}

initListGroupDrawers();
